import { useQuery, useQueryClient } from '@tanstack/react-query';
import { cliengoQueries, CliengoQueryKey } from '@cliengo/mfe-utils/hooks';
import { getCliengoService } from '@cliengo/mfe-utils/services';

export const useRefetchAccountAndPlan = () => {
  const planQueryKey = 'plan';

  const queryClient = useQueryClient();

  const { refetch: refetchAccount } = cliengoQueries.account();

  const { refetch: refetchAccountPlan } = useQuery({
    queryKey: [planQueryKey],
    queryFn: () => getCliengoService().getPlan(),
    staleTime: Infinity,
  });

  const refetchAccountAndPlan = async () => {
    await queryClient.invalidateQueries({
      queryKey: [CliengoQueryKey.account],
    });
    await queryClient.invalidateQueries({ queryKey: [planQueryKey] });

    await refetchAccount();
    await refetchAccountPlan();
  };

  return { refetchAccountAndPlan };
};
